{
  "shipping_methods_page": {
    "header": {
      "title": "Shipping",
      "description": "Shipping Methods let you configure shipping for your B2B customers.",
      "actions": {
        "create": "Create Shipping Method"
      }
    },
    "footer": {
      "description": "Learn more about shipping methods"
    },
    "activation": {
      "optional_note": "Please note, configuring shipping rates is optional.",
      "description": "By default, SparkLayer uses the shipping rates set up in your website's admin and these will automatically show to B2B customers when they checkout. If you'd prefer to set up custom B2B-specific shipping rates, you can enable these here.",
      "enable": "Enable SparkLayer Shipping Rates"
    },
    "table": {
      "caption": "Table of all your Shipping Methods",
      "headings": {
        "name": "Name",
        "countries": "Applicable Countries",
        "groups": "Applicable Customer Groups"
      },
      "row": {
        "sku": "SKU: {sku}",
        "regions_tooltip": "{country} {regions, plural, =0 {(all regions)} =1 {(1 region)} other {({regions} regions)}}"
      }
    },
    "upsell": {
      "title": "Set custom B2B shipping rates.",
      "subtitle": "Shipping Methods let you create B2B-specific shipping rates that show to your wholesale customers at checkout, independent of the rates configured in your store's admin.",
      "available_on": "Available on",
      "starter": "Starter",
      "learn_button": "Learn how shipping works",
      "intro": "Here's what you can do with SparkLayer Shipping:",
      "features": {
        "methods": {
          "title": "Custom shipping methods and rate bands",
          "description": "Create your own B2B shipping methods with rate bands based on order value or weight."
        },
        "targeting": {
          "title": "Target by country and customer group",
          "description": "Apply different rates depending on the destination country and customer group."
        }
      }
    }
  }
}
